import React from 'react';
import { motion } from 'framer-motion';
import './FounderCard.css';

export interface FounderData {
  id: string;
  name: string;
  role: string;
  description: string;
  image: string;
  hasExit: boolean;
}

interface FounderCardProps {
  founder: FounderData;
  index: number;
}

const FounderCard: React.FC<FounderCardProps> = ({ founder, index }) => (
  <motion.article
    className={`founder-card-premium ${founder.hasExit ? 'founder-card-premium--exit' : ''}`}
    data-founder={founder.id}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    whileHover={{ y: -8, rotateX: 4, rotateY: -4 }}
    viewport={{ once: true, margin: '-40px' }}
    transition={{ delay: index * 0.08, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
  >
    <div className="founder-card-premium__media">
      {founder.image ? (
        <img src={founder.image} alt={founder.name} className="founder-card-premium__photo" />
      ) : (
        <div className="founder-card-premium__placeholder">
          {founder.name
            .split(' ')
            .map((n) => n[0])
            .join('')}
        </div>
      )}
      {founder.hasExit ? (
        <span className="founder-card-premium__badge">Founder with previous exit</span>
      ) : null}
    </div>
    <div className="founder-card-premium__body">
      <h3>{founder.name}</h3>
      <p className="founder-card-premium__role">{founder.role}</p>
      <p className="founder-card-premium__bio">{founder.description}</p>
    </div>
  </motion.article>
);

export default FounderCard;
